export const SELECT_CHAPTER = 'SELECT_CHAPTER';
export const SELECT_LESSON = 'SELECT_LESSON';
export const SELECT_REVISION = 'SELECT_REVISION';
export const CLICK_TAB = 'CLICK_TAB';
export const SEARCH_QUEST = 'SEARCH_QUEST';
export const CLEAR_CHAPTER_STATE = 'CLEAR_CHAPTER_STATE';
export const SET_REVISON_VIDEOS = 'SET_REVISON_VIDEOS';
export const TOGGLE_CHAPTER_TIMER = 'TOGGLE_CHAPTER_TIMER';
